<div class="search-div">
  <button mat-raised-button (click)="onCreateForSerials()" data-testid="rb-bundle-createserial-button" [disabled]="
      !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
    ">
    <mat-icon>add</mat-icon>Create Serial Bundle
  </button>
  <button mat-raised-button (click)="onCreateForExperiments()" data-testid="rb-bundle-createexperiment-button" [disabled]="
      !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
    ">
    <mat-icon>add</mat-icon>Create Experiment Bundle
  </button>
  <button mat-raised-button data-testid="rb-bundlelist-createadvanced-button" (click)="onCreateAdvancedBundle()" [disabled]="
      !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
    ">
    <mat-icon>add</mat-icon>Create Advanced Bundle
  </button>
  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input matInput type="text" data-testid="rb-bundlelist-search-input" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="onChange()" />
    <button *ngIf="searchKey" matSuffix mat-icon-button data-testid="rb-bundlelist-search-clear-button" aria-label="Clear search" (click)="onSearchClear()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!searchKey">search</mat-icon>
  </mat-form-field>
  <mat-slide-toggle color="primary" data-testid="rb-bundlelist-mybundles-toggle" [checked]="sliderActive" (change)="toggleSlider()">
    My Bundles
  </mat-slide-toggle>

  <div class="generating-export-container" *ngIf="generatingExport">
    <span class="loading-text">Generating export...</span>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>

<div class="table-container mat-elevation-z1" *ngIf="listData">
  <mat-table [dataSource]="listData" matSort #sort="matSort" data-testid="bundles-table">
    <ng-container matColumnDef="actionsEdit">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button [hidden]="!showEditButton(row)" (click)="onEdit(row)" matTooltip="Edit this Bundle"
          [attr.data-testid]="'edit-bundle-button-' + row.bundleId" [disabled]="
            !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
          ">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-name-' + element.bundleId">{{ element.name
        }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="bundleId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-id-' + element.bundleId">{{ element.bundleId
        }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="isClinicalTrial">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Clinical Trial</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.isClinicalTrial" id="VerifiedIcon">verified</mat-icon>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="assayTypeCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Assay Type</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-assay-type-' + element.bundleId">{{ element |
        bundleAssayTypeFormat }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="bundleTypeName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-type-' + element.bundleId">{{
        element.bundleTypeName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="instrumentTypeName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Instrument Type</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.instrumentTypeName || '-' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="instrumentSerialNumbers">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Instrument S/N</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-instrument-sn-' + element.bundleId" matTooltip="{{
          element.instrumentSerialNumbersCount
            ? '(' + element.instrumentSerialNumbersCount + ')'
            : ''
        }}&nbsp;{{ element.instrumentSerialNumbers }}">
        {{ element.instrumentSerialNumbers }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="experimentIds">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Experiment IDs</mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{
          element.experimentIdsCount ? '(' + element.experimentIdsCount + ')' : ''
        }}&nbsp;{{ element.experimentIds }}">
        {{ element.experimentIds }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-start-date-' + element.bundleId">
        <span *ngIf="element.instrumentSerialNumbers.length > 0">
          {{ element.startDate | date: 'shortDate' }}
        </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>End Date</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-end-date-' + element.bundleId">
        <span *ngIf="element.instrumentSerialNumbers.length > 0">
          {{ element.endDate | date: 'shortDate' }}
        </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dateCreated">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-date-created-' + element.bundleId">{{
        element.dateCreated | date: 'shortDate' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="createdByName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'bundle-created-by-' + element.bundleId">{{
        element.createdByName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actionsDownload">
      <mat-header-cell *matHeaderCellDef>Download</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button [attr.data-testid]="'rb-bundlelist-download-button-' + row.bundleId" (click)="requestBulkDownload(row)"
          matTooltip="Request download by email" [disabled]="
            requestingDownloadBundleIds.has(row.bundleId) ||
            !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
          ">
          <mat-icon>{{ requestingDownloadBundleIds.has(row.bundleId) ? 'hourglass_top' : 'download' }}</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="exportXLSX">
      <mat-header-cell *matHeaderCellDef>Export XLSX</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button [attr.data-testid]="'rb-bundlelist-export-button-' + row.bundleId" [hidden]="row.bundleType == 0 || row.bundleType == 2" (click)="exportXLSX(row)"
          matTooltip="Export XLSX" [disabled]="generatingExport">
          <mat-icon svgIcon="xlsx"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="automatedReports">
      <mat-header-cell *matHeaderCellDef>Data Insights Preview</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button *ngIf="row.isUsedToGenerateReport" mat-icon-button [attr.data-testid]="'rb-bundlelist-reports-button-' + row.bundleId" [hidden]="row.bundleType == 0 || row.bundleType == 2"
          matTooltip="Data Insights Preview" [disabled]="generatingExport" (click)="openAutomatedReports(row)">
          <mat-icon>description</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actionsDelete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button [attr.data-testid]="'rb-bundlelist-delete-button-' + row.bundleId" [hidden]="!showDeleteButton(row)" (click)="onDelete(row)"
          matTooltip="Delete this Bundle" [disabled]="
            !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
          ">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6"> Loading data... </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6"> No data. </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"
      [attr.data-testid]="'bundle-row-' + row.bundleId"></mat-row>
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
    <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{
        hide: !(listData != null && listData.data.length == 0),
      }"></mat-footer-row>
  </mat-table>
</div>
<mat-paginator class="mat-elevation-z1" data-testid="rb-bundlelist-paginator" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
  showFirstLastButtons></mat-paginator>